import logo_trans_200 from '../img/logo_trans_200.png'
import senior_hands_940 from '../img/csss/senior_hands_940.webp'

const Csss = () => {
  
  const styles = {
    backgroundImageStyle: {
      backgroundImage: `url(${senior_hands_940})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    },
    mainDivStyle: {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      backdropFilter: 'blur(5px)'
    }
  }

  return (
	<section
    id='csss'
    className='flex items-center min-h-[350px]' 
    style={styles.backgroundImageStyle}>

      <div className="flex min-h-[350px] w-full items-center" style={styles.mainDivStyle}>
        <div className="flex flex-col md:flex-row h-full container mx-auto items-center justify-center md:pe-60">
          <img src={logo_trans_200} alt="CSS Sokolov" className='w-[200px] md:w-[300px]'/>
          <div className="text-center">
            <h1 className='text-2xl md:text-5xl font-bold ttext-white rounded-md pb-[8px] p-2'>Centrum sociálních služeb Sokolov, o.p.s</h1>
            <p className='text-xl md:text-3xl'>Pečovatelská služba pro Vás a vaše blízké...</p>
          </div>
          
        </div>
      </div>
    </section>
  )
}

export default Csss
